module.exports = __webpack_public_path__ + "static/img/b3.e3dd851f.png";